module.exports = __webpack_public_path__ + "static/img/qmwallet2-parnter_bg.071df2f7.png";